import React, { useEffect, useMemo, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { toast } from "react-toastify";

const AppList = (props) => {
  const { onAdd, onEdit } = props;

  const { sendRequest: getApps } = useHttp();
  const { sendRequest: deleteApp } = useHttp();

  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [openMenuId, setOpenMenuId] = useState(null);

  useEffect(() => {
    fetchAppList();
  }, []);

  const fetchAppList = () => {
    setLoading(true);
    const orgId = localStorage.getItem("orgId");

    getApps(
      {
        url: `/api/app/?orgId=${orgId}`,
      },
      (res) => {
        if (!res) {
          setApps([]);
          setLoading(false);
          return;
        }

        const list = Array.isArray(res)
          ? res
          : res.data || res.results || res.apps || [];

        setApps(Array.isArray(list) ? list : []);
        setLoading(false);
      }
    );
  };

  // -------------------------
  // FILTER LOGIC
  // -------------------------
  const filteredApps = useMemo(() => {
    let data = apps;

    if (searchText.trim() !== "") {
      data = data.filter(
        (a) =>
          a.appName?.toLowerCase().includes(searchText.toLowerCase()) ||
          a.appIdentifier?.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    return [...data].sort((a, b) =>
      (a.appName || "").localeCompare(b.appName || "")
    );
  }, [searchText, apps]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredApps.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // -------------------------
  // DELETE
  // -------------------------
  const handleDelete = (app) => {
    if (!app?.appId) return;

    const confirmed = window.confirm(
      `Are you sure you want to delete "${app.appName}"?`
    );
    if (!confirmed) return;

    const orgId = localStorage.getItem("orgId");
    const userId = localStorage.getItem("userId");

    deleteApp(
      {
        url: `/api/app/`,
        method: "DELETE",
        body: { appId: app.appId, orgId, modifiedBy: userId },
        headers: { "Content-Type": "application/json" },
      },
      (res) => {
        toast.success(res?.message || "App deleted successfully");
        fetchAppList();
      }
    );

    setOpenMenuId(null);
  };

  return (
    <div className="content-wrapper">
      <div className="row mx-2">
        <div className="col-9">
          <label className="card-title mx-3 my-3">Apps</label>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-default">
                <div className="card-body" style={{ padding: "0.4rem" }}>
                  {/* TOP FILTERS */}
                  <div className="row mb-3 mx-1 mt-2">
                    <div className="col-md-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search App..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                    <div className="col-md-5" />
                    <div className="col-md-3 text-right">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onAdd}
                      >
                        <i className="fas fa-plus"></i> Add App
                      </button>
                    </div>
                  </div>

                  {/* TABLE */}
                  {loading ? (
                    <p className="text-muted text-center">Loading apps...</p>
                  ) : currentItems.length === 0 ? (
                    <p className="text-muted text-center">No apps found.</p>
                  ) : (
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>App Name</th>
                          <th>Identifier</th>
                          <th>Bucket</th>
                          <th>Production Path</th>
                          {/* <th>Actions</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((app) => (
                          <tr key={app.appId}>
                            <td>{app.appName}</td>
                            <td>{app.appIdentifier}</td>
                            <td>{app.bucket}</td>
                            <td>{app.productionPath}</td>
                            {/* <td style={{ position: "relative" }}>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() =>
                                  setOpenMenuId(
                                    openMenuId === app.appId ? null : app.appId
                                  )
                                }
                              >
                                <i className="fas fa-ellipsis-v"></i>
                              </button>

                              {openMenuId === app.appId && (
                                <div
                                  className="dropdown-menu show"
                                  style={{
                                    position: "absolute",
                                    right: 0,
                                    top: "100%",
                                    zIndex: 10,
                                  }}
                                >
                                  <button
                                    className="dropdown-item"
                                    type="button"
                                    onClick={() => {
                                      onEdit(app);
                                      setOpenMenuId(null);
                                    }}
                                  >
                                    <i className="fas fa-edit mr-1"></i> Edit
                                  </button>
                                  <button
                                    className="dropdown-item text-danger"
                                    type="button"
                                    onClick={() => handleDelete(app)}
                                  >
                                    <i className="fas fa-trash mr-1"></i> Delete
                                  </button>
                                </div>
                              )}
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="card-footer clearfix">
                  <Pagination
                    totalItems={filteredApps.length}
                    itemsPerPage={itemsPerPage}
                    onPageChange={paginate}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AppList;